export default __webpack_public_path__ + "static/media/_DSC0520-thumb.07345720.jpg";